import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/business/containerLadingOrder/page',
    method: 'get',
    params
  })
}

export function list(params) {
  return request({
    url: '/api/business/containerLadingOrder/list',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/business/containerLadingOrder',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/business/containerLadingOrder',
    method: 'put',
    data
  })
}

export function updateCutoff(data) {
  return request({
    url: '/api/business/containerLadingOrder/updateCutoff',
    method: 'put',
    data
  })
}

export function updateBookingStatus(data) {
  return request({
    url: '/api/business/containerLadingOrder/updateBookingStatus',
    method: 'put',
    data
  })
}

export function updateCustomsCutoffTime(data) {
  return request({
    url: '/api/business/containerLadingOrder/updateCustomsCutoffTime',
    method: 'put',
    data
  })
}

export function updateCustomsClearanceStatus(data) {
  return request({
    url: '/api/business/containerLadingOrder/updateCustomsClearanceStatus',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/business/containerLadingOrder/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/business/containerLadingOrder',
    method: 'get',
    params: {
      id
    }
  })
}
export function profitPage(params) {
  return request({
    url: '/api/business/containerLadingOrder/profitPage',
    method: 'get',
    params
  })
}
export function profitDetail(params) {
  return request({
    url: '/api/business/containerLadingOrder/profitDetail',
    method: 'get',
    params
  })
}
export function profit(params) {
  return request({
    url: '/api/business/containerLadingOrder/profit',
    method: 'get',
    params
  })
}
export function exportContainerLadingOrderData(params) {
  return request({
    url: '/api/business/containerLadingOrder/exportContainerLadingOrderData',
    method: 'post',
    params
  })
}
